module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-gallery"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (_vm.props) ? _c('div', [_c('Hero', {
    attrs: {
      "props": _vm.props.acf.hero
    }
  }), _c('HeadBar', {
    attrs: {
      "props": _vm.props.acf.header
    }
  }), _c('div', {
    staticClass: "page-gallery__office-photos"
  }, _vm._l((_vm.props.acf.office.repeater), function(pic, i) {
    return _c('div', {
      key: i,
      staticClass: "page-gallery__office-photo-container"
    }, [_c('a', {
      attrs: {
        "data-fancybox": "gallery",
        "href": pic.image.src
      }
    }, [_c('img', {
      staticClass: "page-gallery__office-photo",
      attrs: {
        "src": pic.image.src,
        "alt": pic.image.alt
      }
    })])])
  }))], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0855123c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/office-gallery/office-gallery.pug
// module id = 581
// module chunks = 1